import { render, staticRenderFns } from "./BrowserLanguageModal.vue?vue&type=template&id=285102c5&"
import script from "./BrowserLanguageModal.vue?vue&type=script&lang=js&"
export * from "./BrowserLanguageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports